import { render, staticRenderFns } from "./tem_page.vue?vue&type=template&id=78baf8ef&"
import script from "./tem_page.vue?vue&type=script&lang=js&"
export * from "./tem_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports